import React from 'react';
import { IndexRoute, Route } from 'react-router';
import TransferRequests from './transferRequests';

export default (
  <Route path="transferencias">
    <IndexRoute component={props => <TransferRequests {...props} />} />
  </Route>
);
